<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="applyFilters(); loadItems(); showFilters = false;"
                >Apply</b-button>
              </div>
              <div class="col-auto text-right">
                <b-button type="reset" variant="outline-danger" @click="resetFormFilters()">Reset</b-button>
                <b-button variant="outline-secondary" class="ml-1" @click="showFilters = false; formFilters = { ...itemsFilters };">Cancel</b-button>
              </div>
            </b-row>
          </div>
          <div class="px-3 py-2">
            <b-form-group label="Client:">
              <b-v-select
                v-model="formFilters.brandId"
                :searchable="true"
                :options="brandsFilter"
              />
            </b-form-group>
            <b-form-group label="Integration System:">
              <b-v-select
                v-model="formFilters.integrationSystem"
                :options="integrationSystemOpts"
              />
            </b-form-group>
            <b-form-group label="Status:">
              <b-v-select
                v-model="formFilters.integrationStatus"
                :options="integrationStatusOpts"
              />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">Third Party Apps</h1>
            <ActiveFiltersCard
              :itemsFilters="itemsFilters"
              :resetFilterWithKey="resetFilterWithKey"
              :loadItems="loadItems"
            />
          </div>
          <div class="col-auto">
            <router-link
              v-if="has('pm.integrations.orderSourceIntegrations.edit')"
              :to="{ name: 'Integrations.ThirdPartyApps.Create' }"
              class="btn btn-success mr-2"
            >
              <i class="mr-2 fa fa-plus" />
              Add New
            </router-link>
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(integrationStatus)="data">
        <ProjectIntegrationStatusBadge :integrationStatus="data.item.integrationStatus" />
      </template>
      <template v-slot:cell(brandId)="data">
        <span v-if="myBrands && myBrands.find(function(a) { return a.id == data.item.brandId; })">
          {{ myBrands.find(function(a) { return a.id == data.item.brandId; }).name }}
        </span>
        <span v-else>-</span>
      </template>
      <template v-slot:cell(createDateTimeUtc)="data">
        <span v-if="data.item.createDateTimeUtc">
          {{ (data.item.createDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a') }}
        </span>
      </template>
      <template v-slot:cell(id)="data">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="$router.push({ name: 'Integrations.ThirdPartyApps.Edit', params: { id: data.item.id } })"
        >Edit</b-button>
      </template>
    </TableListing>
  </section>
</template>

<script>
import ProjectIntegrationStatusBadge from '@/views/components/ProjectIntegrationStatusBadge';
import { TableListing, ActiveFiltersCard } from '@/views/components/custom';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';

export default {
  name: 'Integrations.ThirdPartyApps.Index',
  mixins: [crudMixinGen('thirdPartyIntegrations'), myCommonDataMixin],
  components: {
    TableListing,
    ActiveFiltersCard,
    ProjectIntegrationStatusBadge
  },

  data: function() {
    return {
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'integrationSystem', label: 'System', sortable: true },
        { key: 'brandId', label: 'Client', sortable: true },
        { key: 'integrationStatus', label: 'Status', sortable: true },
        { key: 'createDateTimeUtc', label: 'Created', sortable: true },
        { key: 'id', label: 'Actions', sortable: false }
      ],
      integrationSystemOpts: [
        { value: null, text: 'All' },
        { value: 'LoopReturns', text: 'Loop Returns' }
      ],
      integrationStatusOpts: [
        { value: null, text: 'All' },
        { value: 'Active', text: 'Active' },
        { value: 'Paused', text: 'Paused' },
        { value: 'Pending', text: 'Pending' },
        { value: 'PendingClientAction', text: 'Pending Client Action' },
        { value: 'Disabled', text: 'Disabled' }
      ]
    };
  },

  mounted: function() {
    this.loadItems();
  }
};
</script>
